module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.show_all) ? _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12 position-relative"
  }, [_c('div', {
    staticClass: "c-shop-order__wrapper sm-overflow-scroll orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                          " + _vm._s(order.order_date) + "\r\n                          "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("Tap to view")])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                        " + _vm._s(order.order_business) + "\r\n                        "), _c('br'), _vm._v(" "), _vm._l((order.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })])
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.show_single) ? _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": _vm.viewOrders
    }
  }, [_vm._v("X")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.is_new) ? _c('h3', {
    staticClass: "text-align-center margin-bottom-double"
  }, [_vm._v("Thank you. Your order has been received.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv"
  }, [_c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Order number:")]), _vm._v(" " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Order Amount:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Shipping:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Total:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Delivery Location:")]), _vm._v(" " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.order.order_user_delivery_address))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12 position-relative"
  }, [_c('div', {
    staticClass: "c-shop-order__wrapper sm-overflow-scroll orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                        " + _vm._s(item.order_item_no) + "\r\n                      ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + "\r\n                        "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section is-dark is-header md-margin-top-24"
  }, [_c('div', {
    staticClass: "container margin-top"
  }, [_c('div', {
    staticClass: "col block-centered text-align-center lg-7 md-12"
  }, [_c('h1', {
    staticClass: "on-dark"
  }, [_vm._v("Your Orders")]), _vm._v(" "), _c('div', {
    staticClass: "padding-left padding-right margin-bottom low-text-contrast on-dark"
  }, [_vm._v("Placed Orders "), _c('a', {
    staticClass: "on-dark",
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("Continue shopping")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Payment method:")]), _vm._v(" Online Payment")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81637c5a"}!./src/pages/Orderpoint/Orders/template.html
// module id = 253
// module chunks = 0